import { formatPrice, resolveByCountry } from '@codex/helpers';

export function convertProductToAjaxAPIProductFormat(product) {
  const currency = resolveByCountry('GBP', 'EUR');
  const convertedProduct = {
    price: {},
    channelsAvailability: {
      defaultAvailability: {}
    }
  };

  // required props
  convertedProduct.id = product.productID;
  convertedProduct.link = product.productUrl;
  convertedProduct.image = {
    src: product.imageUrl || '#'
  };
  convertedProduct.title = product.productName;
  convertedProduct.price.price =
    formatPrice(product.currentPrice, false, currency);
  convertedProduct.isOutOfStock = !product.inStock;
  convertedProduct.isComboKit = product.isBundle;
  convertedProduct.channelsAvailability.defaultAvailability.showEmailMeBack =
    product.emailMeBack;
  convertedProduct.brand = {
    title: product.manufacturer
  };

  // optional props
  if (product.subItemNames && product.subItemNames.length > 0) {
    convertedProduct.comboKitItemNames = product.subItemNames.slice(1);
  }
  if (product.mainProductCurrentPrice) {
    convertedProduct.price.mainProductCurrentPrice =
      formatPrice(product.mainProductCurrentPrice, false, currency);
  }
  if (product.mainProductWasPrice) {
    convertedProduct.price.mainProductWasPrice =
      formatPrice(product.mainProductWasPrice, false, currency);
  }
  if (product.savingsPrice) {
    convertedProduct.price.savingsPrice =
      formatPrice(product.savingsPrice, false, currency);
  }
  if (product.separateSellingPrice) {
    convertedProduct.price.separateSellingPrice =
      formatPrice(product.separateSellingPrice, false, currency);
  }
  if (product.wasPrice) {
    convertedProduct.price.wasPrice =
      formatPrice(product.wasPrice, false, currency);
  }
  if (product.wasPriceFrom) {
    convertedProduct.price.wasPriceFrom = product.wasPriceFrom;
  }
  if (product.wasPriceTo) {
    convertedProduct.price.wasPriceTo = product.wasPriceTo;
  }

  return convertedProduct;
}
